import { createSelector } from 'reselect';
export const getConnections = state => state.connections;

export const getConnectionCompanies = createSelector([getConnections], connections => connections.connectionCompanies);
